<template>
    <div class="Asides">
        <div>
            <div v-for="(item, index) in subItems" v-if="index + 1 == activeRoute">
                <div class="active titles">
                    <img src="https://oss.sbooip.com/static/www/pc/assets/images/iconred.png" alt="" class="iconlogo">
                    {{ item.title }}
                </div>
                <div v-for="sub in item.sub">
                    <router-link :to="sub.path" active-class="active">
                        <div @click="changeActive(index + 1)">{{ sub.name }}</div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
    name: "Asides",
    components: {},
    data() {
        return {
            subItems: [
                {
                    title: '关于我们',
                    sub: [
                        { name: '公司简介', path: '/About/Company' },
                        { name: '发展历程', path: '/About/History' },
                        { name: '荣誉资质', path: '/About/Qualification' },
                        { name: '团队风采', path: '/About/TeamSpirit' },
                        { name: '合作客户', path: '/About/CooperativeClients' },
                        { name: '案例展示', path: '/About/CaseShowcase' },
                        { name: '人才招聘', path: '/About/TalentRecruitment' }
                    ]
                },
                {
                    title: '商标注册',
                    sub: [
                        { name: '查询与设计', path: '/Trademark/SearchDesign' },
                        { name: '续展与变更', path: '/Trademark/Renewal' },
                        { name: '异议与撤三', path: '/Trademark/NonCancellation' },
                        { name: '答辩与复审', path: '/Trademark/AnswerReview' },
                        { name: '监测与维权', path: '/Trademark/Surveillance' }
                    ]
                },
                {
                    title: '专利申请',
                    sub: [
                        { name: '检索与撰写', path: '/Patent/SearchWrite' },
                        { name: '无效与答辩', path: '/Patent/InvalidationResponse' },
                        { name: '转让与许可', path: '/Patent/TransferLicense' },
                        { name: '优审与快审', path: '/Patent/FastExamination' },
                        { name: '布局与规划', path: '/Patent/Planning' }
                    ]
                },
                {
                    title: '版权登记',
                    sub: [
                        { name: '作品登记', path: '/Copyright/Registration' },
                        { name: '作品维权', path: '/Copyright/RightsProtection' }
                    ]
                },
                {
                    title: '知产维权',
                    sub: [
                        { name: '发明专利维权', path: '/knowledge/InventionPatent' },
                        { name: '实用新型专利维权', path: '/knowledge/UtilityPatent' },
                        { name: '外观设计专利维权', path: '/knowledge/DesignPatent' },
                        { name: '商品商标维权', path: '/knowledge/GoodsTrademark' },
                        { name: '服务商标维权', path: '/knowledge/ServiceMark' },
                        { name: '著作权维权', path: '/knowledge/CopyrightRights' }
                    ]
                },
                {
                    title: '动态资讯',
                    sub: [
                        { name: '全部', path: '/IndustryNews/AllNews' },
                        { name: '行业新闻', path: '/IndustryNews/SectorNews' },
                        { name: '公司动态', path: '/IndustryNews/CompanyNews' },
                        { name: '知识分享', path: '/IndustryNews/KnowledgeSharing' }
                    ]
                }
            ]
        };
    },
    computed: {
        // 获取store中的数据,mapStates数组写法
        ...mapState('home', ['activeRoute']),
    },
    methods: {
        //方式二：借助mapMutations 调用commit
        ...mapMutations('home', ['SETACTIVE', 'ACTIVEJIA', 'ACTIVEJIAN']),
        // 更改选中下标
        changeActive(i) {
            this.SETACTIVE(i)
            // 隐藏二级菜单
            this.$emit('custom-event', i);
        }
    },
    mounted() {
        //   console.log(this.activeRoute)
    },
}
</script>
<style lang='scss' scoped>
a {
    text-decoration: none;
    color: rgb(83, 83, 83);
}

.Asides {
    background-color: #dbdada;
    position: fixed;
    top: 50%;
    left: 40px;
    transform: translateY(-50%);
    border-radius: 8px;
    div {
        padding: 7px 16px;
        font-size: 15px;
        cursor: pointer;

        &:hover {
            color: red;
        }
    }

    z-index: 10;
}

.titles {
    display: flex !important;
    align-items: center !important;
    padding: 8px !important;
    margin: 0 !important;
    font-size: 18px !important;
}

.iconlogo {
    height: 20px;
    margin-right: 8px;
}

.active {
    color: red !important;
    font-weight: bold;
}
</style>